module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_vestfold_telemark_neg.4dc8b288.png";